/* =============================================
 * 项目入口文件
 * 结构分层：样式导入 → 核心依赖 → 插件注册 → 全局组件 → 原型挂载 → 实例化
 * ============================================= */

// ========== 1. 核心基础依赖 ==========
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store/index.js";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";

// ========== 2. 全局样式 ==========
import '@/assets/css/page-optimize.css'
// 布局主题样式（新增）
import '@/styles/theme/index.less'
// 阿里图标库
import "@/assets/al-icon/tubiao-126/iconfont.css";
import "@/assets/al-icon/tubiao-154/iconfont.css";
// CSS动画库
import "animate.css";


// ========== 3. 第三方插件 ==========
import VueClipboard from "vue-clipboard2";
import VueContextMenu from "@xunlei/vue-context-menu";
import VueAwesomeSwiper from "vue-awesome-swiper";
import dataV from "@jiaminghi/data-view";
import qs from "qs";
import lrz from "lrz";

// ========== 4. 业务配置与工具 ==========
import api from "@/https/api";
import config from "./config";
import common from "./common/common.js";
import IdCard from "./common/idCard";
import tokenManager from "./config/tokenManager.js";

// 初始化Token管理器
tokenManager.init(Vue, router);
// 全局挂载路由（保留原有逻辑，不推荐但兼容现有代码）
window.$vueRouter = router;

// ========== 5. 插件注册 ==========
Vue.use(ElementUI, { size: "small" });
Vue.use(VueClipboard);
Vue.use(VueContextMenu);
Vue.use(VueAwesomeSwiper);
Vue.use(dataV);

// ========== 6. 全局组件注册 ==========
import KtButton from "@/components/common/ktButton.vue";
import BreadCrumb from "@/components/BreadCrumb";
import Headtitle from "@/components/common/Headtitle";
import LbTable from "@/components/lb-table/lb-table";
import wanEditor from "@/components/wanEditor2";
import vdr from "vue-draggable-resizable-gorkys";
import "vue-draggable-resizable-gorkys/dist/VueDraggableResizable.css";
// 列设置
import OpColumnSetting from '@/components/OpColumnSetting';


Vue.component("KtButton", KtButton);
Vue.component("BreadCrumb", BreadCrumb);
Vue.component("Headtitle", Headtitle);
Vue.component("LbTable", LbTable);
Vue.component("wanEditor", wanEditor);
Vue.component("vdr", vdr);
// 列设置
Vue.component('op-column-setting', OpColumnSetting);

// ========== 7. 原型挂载 ==========
Vue.prototype.$api = api;
Vue.prototype.$qs = qs;
Vue.prototype.common = common;
Vue.prototype.validid = IdCard;

// ========== 8. 根实例化 ==========
Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");

/* =============================================
 * 历史注释代码（保留备查，不执行）
 * =============================================
// 百度地图
// import VueBaiduMap from 'vue-baidu-map'
// Vue.use(VueBaiduMap.default, { ak: 'YOUR_APP_KEY' })

// 路由历史记录
// var routeList = [];
// router.beforeEach((to, from, next) => {
//   var index = -1;
//   for (var i = 0; i < routeList.length; i++) {
//     if (routeList[i].name == to.name) {
//       index = i;
//       break;
//     }
//   }
//   if (index !== -1) {
//     routeList.splice(index + 1, routeList.length - index - 1);
//   } else if (to.name != "登录") {
//     routeList.push({ name: to.name, path: to.fullPath });
//   }
//   to.meta.routeList = routeList;
//   next();
// });

// 登录超时检测
// Vue.prototype.overTime = () => {
//   var lastTime = new Date().getTime();
//   var currentTime = new Date().getTime();
//   var timeOut = 300 * 1000;
//   sessionStorage.setItem("lastTime", new Date().getTime());
//   window.document.onmousedown = function () {
//     sessionStorage.setItem("lastTime", new Date().getTime());
//   };
//   function checkTimeout() {
//     currentTime = new Date().getTime();
//     lastTime = sessionStorage.getItem("lastTime");
//     if (currentTime - lastTime > timeOut) {
//       if (window.int != "undefined") {
//         window.clearInterval(window.int);
//       }
//       sessionStorage.clear();
//       let url = window.location.href;
//       if (url.indexOf("/M/newIndex") != -1) {
//         router.push("/M/newIndex");
//       } else if (url.indexOf("/M/noIndex") != -1) {
//         router.push("/M/noIndex");
//       } else {
//         router.push("/login");
//       }
//     }
//   }
//   window.int = setInterval(function () {
//     checkTimeout();
//   }, 10000);
// };
*/



// import "element-ui/lib/theme-chalk/index.css";
// import Vue from "vue";
// import App from "./App.vue";
// import ElementUI from "element-ui";
// import router from "./router";
// import api from "@/https/api";
// import store from "./store/index.js";
// import lrz from "lrz";
// import '@/assets/css/page-optimize.css'
// // Vue.use(VueBaiduMap.default, {
// //     ak: 'YOUR_APP_KEY',
// // })

// import tokenManager from "./config/tokenManager.js"
// // 初始化Token管理器（传入Vue和Router，核心！）
// tokenManager.init(Vue, router);
// // 全局挂载Router（供tokenManager内部跳转使用）
// window.$vueRouter = router;
// // 公共方法
// import common from "./common/common.js";
// //css3动画
// import animated from "animate.css";
// Vue.use(animated);
// //复制功能
// import VueClipboard from "vue-clipboard2";
// //从阿里巴巴引入图标
// import "../src/assets/al-icon/tubiao-126/iconfont.css";
// import "../src/assets/al-icon/tubiao-154/iconfont.css";

// import config from "./config";
// import VueContextMenu from "@xunlei/vue-context-menu";
// //身份证
// import IdCard from "./common/idCard";
// //面包屑
// import BreadCrumb from "@/components/BreadCrumb";
// // 页面标题
// import Headtitle from "@/components/common/Headtitle";

// // 表格
// import LbTable from "@/components/lb-table/lb-table";
// // 文本
// import wanEditor from "@/components/wanEditor2";

// // 按钮组件 全局使用
// import KtButton from "@/components/common/ktButton.vue";

// Vue.component("KtButton", KtButton);

// // / 通知书内组件
// import vdr from "vue-draggable-resizable-gorkys";
// import "vue-draggable-resizable-gorkys/dist/VueDraggableResizable.css";
// Vue.component("vdr", vdr);

// //swiper轮播

// import VueAwesomeSwiper from "vue-awesome-swiper";
// Vue.use(VueAwesomeSwiper);
// import qs from "qs";

// Vue.component("wanEditor", wanEditor);
// Vue.component("BreadCrumb", BreadCrumb);
// Vue.component("Headtitle", Headtitle);
// Vue.component("LbTable", LbTable);
// import dataV from "@jiaminghi/data-view";
// Vue.use(dataV);
// Vue.prototype.validid = IdCard; //验证身份证
// Vue.prototype.common = common;
// Vue.config.productionTip = false;
// Vue.prototype.$qs = qs;
// Vue.prototype.$api = api;
// Vue.use(ElementUI, { size: "small" });
// Vue.use(VueContextMenu);
// Vue.use(VueClipboard);
// new Vue({
//   el: "#app",
//   router,
//   store,
//   render: (h) => h(App),
// }).$mount("#app");

// // var routeList = [];
// // router.beforeEach((to, from, next) => {
// //   var index = -1;
// //   for (var i = 0; i < routeList.length; i++) {
// //     if (routeList[i].name == to.name) {
// //       index = i;
// //       break;
// //     }
// //   }
// //   if (index !== -1) {
// //     //如果存在路由列表，则把之后的路由都删掉
// //     routeList.splice(index + 1, routeList.length - index - 1);
// //   } else if (to.name != "登录") {
// //     routeList.push({ name: to.name, path: to.fullPath });
// //   }
// //   to.meta.routeList = routeList;
// //   next();
// // });

// // 登录超时
// // Vue.prototype.overTime = () => {
// //   var lastTime = new Date().getTime();
// //   var currentTime = new Date().getTime();
// //   var timeOut = 300 * 1000; //设置超时时间： 5分
// //   sessionStorage.setItem("lastTime", new Date().getTime());
// //   window.document.onmousedown = function () {
// //     sessionStorage.setItem("lastTime", new Date().getTime());
// //   };

// //   function checkTimeout() {
// //     currentTime = new Date().getTime(); //更新当前时间
// //     lastTime = sessionStorage.getItem("lastTime");
// //     if (currentTime - lastTime > timeOut) {
// //       //判断是否超时
// //       if (window.int != "undefined") {
// //         window.clearInterval(window.int);
// //       }
// //       //console.log('超时未操作')
// //       //yrx修改，超时退出
// //       sessionStorage.clear();
// //       // localStorage.removeItem('token');
// //       router.push("/login");

// //       //Mindex 页面不跳转到登录页 Yrx
// //       let url = window.location.href;
// //       if (url.indexOf("/M/newIndex") != -1) {
// //         router.push("/M/newIndex");
// //         console.log("//Mindex 页面不跳转到登录页");
// //       } else if (url.indexOf("/M/noIndex") != -1) {
// //         router.push("/M/noIndex");
// //       } else {
// //         router.push("/login");
// //       }
// //     }
// //   } /* 定时器 间隔30秒检测是否长时间未操作页面 */
// //   window.int = setInterval(function () {
// //     checkTimeout();
// //   }, 10000);
// // };
